// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"offerPaidHits__gradient-bg5__uKZxC","offerPaidHits":"offerPaidHits__offerPaidHits__WAUQG"};